<div class="login-container">

  <alert></alert>


  <div class="content-container">

    <section class="card-login" *ngIf="!actionCompleted">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <img class="avux-logo" src="/assets/img/logo/avux-lg-green.svg" alt="Avux logo">
            <language-select></language-select>
        </div>
        <div class="d-flex align-items-center justify-content-start mt-3">
            <!-- <i class="card-icon fa-regular fa-key"></i> -->
            <span class="logon-text">{{'login.reset_password' | translate}}</span>
        </div>
      </div>

      <div class="card-body">
        <form [formGroup]="resetpwForm" (ngSubmit)="onSubmit()">


          <div class="form-group">
            <b><label kupari-label for="passphrase" [class]="'control-label mb-1'"
              [text]="'user.my_account.new_passphrase'"></label></b>
            <kupari-input
              [placeholder]="'user.my_account.new_passphrase'"
              [icon]="'fa-light fa-lock'"
            formControlName="passphrase" [type]="'password'" [id]="'passphrase'" [class]="'form-control'">
            </kupari-input>
          </div>

          <div class="form-group">
            <b><label kupari-label for="confirmPassphrase" [class]="'control-label mb-1'"
              [text]="'user.my_account.confirm_new_passphrase'"></label></b>
            <kupari-input
            [icon]="'fa-light fa-lock'"
            [placeholder]="'user.my_account.confirm_new_passphrase'" formControlName="confirmPassphrase" [type]="'password'" [id]="'confirmPassphrase'"
              [class]="'form-control'" [validation]="[{
              rule:resetpwForm.get('confirmPassphrase').touched && !resetpwForm.get('confirmPassphrase').valid,
              message:'common.errors.required_field'
            },{
            rule:f.confirmPassphrase.touched && resetpwForm.errors?.notSame,
            message:'user.errors.passphrases_dont_match'
          }]">
            </kupari-input>

          </div>

          <div class="form-group justify-content-center">
            <kupari-button [type]="'submit'" [class]="'btn btn-primary w-100 bolder-button shadow'" [text]="'login.reset_password'">
            </kupari-button>
          </div>

        </form>
        <div class="text-center">
          <a class="d-block small mt-3" [routerLink]="['/login']">
            <b>{{'login.abort_return_to_login' | translate}}</b>
          </a>
        </div>
      </div>
      <div class="card-footer">
        <app-login-footer></app-login-footer>
      </div>
    </section>

    <section class="card-login" *ngIf="actionCompleted">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <img class="avux-logo" src="/assets/img/logo/avux-lg-green.svg" alt="Avux logo">
            <language-select></language-select>
        </div>
        <div class="d-flex align-items-center justify-content-start mt-3">
            <!-- <i class="card-icon fa-regular fa-key"></i> -->
            <span class="logon-text">{{'login.reset_success_header' | translate}}</span>
        </div>
      </div>
      <div class="card-body">
        <p>{{'login.reset_success' | translate}}</p>
        <div class="d-flex justify-content-center">
          <a [routerLink]="['/login']" class="btn btn-primary w-100 bolder-button shadow">
            {{'login.return_to_login' | translate}}
          </a>
        </div>
      </div>
      <div class="card-footer">
        <app-login-footer></app-login-footer>
      </div>
    </section>

  </div>
  <div class="brand-image-container">
  </div>




</div>
